const Tag = () =>
  import(/* webpackChunkName: "blog-tag" */ '@/pages/blog/blog/tag/index.vue')

const CreateTag = () =>
  import(
    /* webpackChunkName: "blog-tag" */ '@/pages/blog/blog/tag/create.vue'
  )

const EditTag = () =>
  import(/* webpackChunkName: "blog-tag" */ '@/pages/blog/blog/tag/edit.vue')

export default {
  path: 'tag',
  meta: {
    label: 'tag',
    auth: 'tag'
  },
  component: {
    name: 'Tag',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BlogTagReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Tag
    },
    {
      name: 'BlogCreateTag',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateTag
    },
    {
      name: 'BlogEditTag',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditTag,
      props: true
    }
  ]
}
